import Header from "../../../components/header/Header";
import StarChartMainContainer from "../conatiner/starChart.main.container/starCharts.main.container";


const StarChartPage = () => {


  return (
    <>
      <Header title="Star Chart Base" />
      <StarChartMainContainer />
    </>
  )
}

export default StarChartPage
